import { graphql, useStaticQuery } from 'gatsby';
import { useContext, useEffect, useState } from 'react';
import sanitizeHtml from 'sanitize-html';
import GlobalContext from '../../../contexts/globalContext';
import useMobile from '../../../hooks/useMobile';
import HomeServices from '../../../services/home-services';
import useBrowserMode from '../../../shared/hooks/useBrowserMode';
import GenericToast from '../../atoms/generic-toast/genericToast';
import Loader from '../../atoms/loader/loader';
import Cookies from 'universal-cookie';
import './pdfViewModal.scss';
interface PdfViewModalInterface {
    base64: any;
    selectedFileName: string;
    setActiveModal?: (any) => void;
    setActiveToast?: (any) => void;
    type?: string;
}
const PdfViewModal = ({
    base64,
    selectedFileName,
    setActiveModal,
}: PdfViewModalInterface) => {
    const data = useStaticQuery(graphql`
        query GET_PORTAL_SERVICIOS_VISTA_PREVIA_DATA {
            allContentfulTemplate(
                filter: { titulo: { eq: "Vista previa de X certificado" } }
            ) {
                nodes {
                    imagen {
                        title
                        file {
                            url
                        }
                    }
                    referencias {
                        ... on ContentfulTemplate {
                            nombre
                            copyBoton
                            imagen {
                                title
                                file {
                                    url
                                }
                            }
                        }
                    }
                }
            }
        }
    `);

    const content = data?.allContentfulTemplate?.nodes[0]?.referencias;
    const [email, setEmail] = useState<any>();
    const [confirmationToast, setConfirmationToast] = useState<any>(false);
    const [loader, setLoader] = useState(false);
    const { gigyaContext, userInfoContext } = useContext(GlobalContext);
    const mobile = useMobile();
    const cookies = new Cookies();
    const { localStorage } = useBrowserMode();

    useEffect(() => {
        document.documentElement.style.overflowY = 'hidden';
        return () => {
            document.documentElement.style.overflowY = 'scroll';
        };
    }, []);

    const sendEmail = () => {
        if (email && email !== ' ' && /\S/.test(email)) {
            if (
                (gigyaContext &&
                    userInfoContext &&
                    userInfoContext.data?.userJwt) ||
                cookies.get('token')
            ) {
                setLoader(true);
                const config = {
                    headers: {
                        Authorization: userInfoContext.data?.userJwt
                            ? userInfoContext.data?.userJwt
                            : cookies.get('token'),
                    },
                };

                const payload = {
                    attachments: [
                        {
                            contentBytes: base64,
                            contentType: 'PDF',
                            name: selectedFileName + '.pdf',
                        },
                    ],
                    params: [
                        {
                            field: '<<NombreCertificado>>',
                            value: selectedFileName,
                        },
                    ],
                    template: 'certificado',
                    toRecipients: [
                        {
                            emailAddress: {
                                address: sanitizeHtml(email),
                            },
                        },
                    ],
                };

                HomeServices.sendCertificateEmail(payload, config)
                    .then((response) => {
                        setLoader(false);
                        if (response.status === 200) {
                            setConfirmationToast(
                                <GenericToast
                                    setActiveToast={setConfirmationToast}
                                    isOk={true}
                                    message="El correo fue enviado con éxito"
                                    position="up-right"
                                />
                            );
                            setEmail('');

                            window.dataLayer = window.dataLayer || [];
                            window.dataLayer.push({
                                event: 'pushEventGA',
                                category:
                                    localStorage.getItem('CURRENT_TAB') ===
                                    'personas'
                                        ? 'HomePersonas'
                                        : 'HomeEmpresas',
                                action: 'ClicCertificado',
                                label: selectedFileName + ' :: EnvioExitoso',
                            });
                        } else {
                            setConfirmationToast(
                                <GenericToast
                                    setActiveToast={setConfirmationToast}
                                    isOk={false}
                                    message="¡Ups! No fue posible enviar el correo, verifica que esté bien escrito"
                                    position="up-right"
                                />
                            );
                        }
                    })
                    .catch((e) => {
                        console.error(e);
                        setLoader(false);
                        setConfirmationToast(
                            <GenericToast
                                setActiveToast={setConfirmationToast}
                                isOk={false}
                                message="¡Ups! No fue posible enviar el correo, verifica que esté bien escrito"
                                position="up-right"
                            />
                        );
                    });
            }
        } else {
            setConfirmationToast(
                <GenericToast
                    setActiveToast={setConfirmationToast}
                    isOk={false}
                    message="Por favor escribe un correo"
                    position="up-right"
                />
            );
        }
    };

    const downlaodPDF = (base64, reference) => {
        const byteCharacters = atob(base64);

        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        try {
            const file = new Blob([byteArray], { type: 'application/pdf' });
            const link = document.createElement('a');
            link.href = window?.URL.createObjectURL(file);
            const fileName = reference;
            link.download = fileName;
            link.click();
        } catch (e) {
            console.error(e);
        }
    };

    useEffect(() => {
        downlaodPDF(base64, selectedFileName);
    }, []);

    return (
        <div className="m-pdf-view-modal">
            {confirmationToast && <>{confirmationToast}</>}
            <div className="m-pdf-view-modal__content">
                <div className="m-pdf-view-modal__content__body">
                    <object
                        data={'data:application/pdf;base64,' + base64}
                        type="application/pdf"
                        name={selectedFileName}
                    >
                        <param name="src" value={selectedFileName} />
                        alt :<a href="#" download={selectedFileName} />
                    </object>
                </div>
                <div className="m-pdf-view-modal__content__header">
                    {!mobile &&
                        data?.allContentfulTemplate?.nodes[0].imagen &&
                        data?.allContentfulTemplate?.nodes[0].imagen[0] && (
                            <img
                                src={
                                    data?.allContentfulTemplate?.nodes[0]
                                        .imagen[0].file.url
                                }
                                alt={
                                    data?.allContentfulTemplate?.nodes[0]
                                        .imagen[0].title
                                }
                                title={
                                    data?.allContentfulTemplate?.nodes[0]
                                        .imagen[0].title
                                }
                                className="m-pdf-view-modal__content__header__image"
                            />
                        )}
                    <div className="m-pdf-view-modal__content__header__input">
                        <input
                            type={'email'}
                            value={email}
                            onChange={(e) => {
                                setEmail(e.target.value);
                            }}
                            placeholder={
                                content && content[0].nombre
                                    ? content[0].nombre
                                    : 'Escribe el correo al que deseas enviar el PDF'
                            }
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    sendEmail();
                                }
                            }}
                        />
                        <button onClick={sendEmail} disabled={!email}>
                            {loader ? (
                                <Loader size={'__small'} />
                            ) : (
                                content[0].copyBoton
                            )}
                        </button>
                    </div>
                    <span
                        onClick={() => {
                            setActiveModal && setActiveModal(false);
                        }}
                    >
                        {!mobile && 'Cerrar'}
                        <i className="icon-close"></i>
                    </span>
                </div>
            </div>
        </div>
    );
};

export default PdfViewModal;
